import React from 'react'
import PropTypes from 'prop-types'

import Radio from 'components/settings/Radio'

const RadioList = ({ name, value, items, onChange }) => {
  return (
    <React.Fragment>
      {items.map((item, i) => (
        <Radio
          key={`${name}_${item.value}`}
          name={name}
          value={item.value}
          label={item.label}
          isChecked={value === item.value}
          onChange={onChange}
          isLast={!(i < items.length - 1)}
        />
      ))}
    </React.Fragment>
  )
}

RadioList.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func.isRequired
}

export default RadioList



// WEBPACK FOOTER //
// ./src/components/settings/RadioList.js